"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommonSpinner_1 = require("./CommonSpinner");
exports.default = CommonSpinner_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CommonSpinner/index.js
// module id = 261
// module chunks = 8